


































































































































































import AddGeoFence from './AddGeoFence.vue';

const POINT_OF_INTEREST_KEY = 'point_of_interest_id';
const GEO_FENCE_KEY = 'geofence_id';

import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import MapLoader from './MapLoader.vue';
import ContextMenu  from '../ContextMenu.vue';
import {
    contact,
    Geofence,
    Marker,
    moderating,
    off,
    on_driving_working,
    outdated,
    Point,
    PointsOfInterest,
    GeofenceAdd,
    PolygonComplete,
    CompletePoint,
    Polygon,
    TypeFilterDate,
    white
} from '../../models';
import DrawRoutes from './DrawRoutes.vue';
import DrawVisualizations from './DrawVisualizations.vue';
import {
    ElementId,
    getDateFromDateFormatApi,
    hasElements,
    InfoWindowID,
    LegendMap,
    MarkerVehicleHistoricalUUID,
    Method,
    PlayBackInfo,
    PlaybackState,
    SearchOfGeoFence,
    SearchOfInterest,
    trackingColors,
    trackingUnselectedColor,
    TypeVehicleState,
    EventBus,
    TypeEventBus,
    VisualizationInfo,
    getPositionsFiltered,
    PRIVILEGE_KEYS,
    PRIVILEGE_TYPES,
    polygonsAreValid,
    GeofenceElement,
    ColorsList,
    customPinElement,
    customSvgForMarker,
    // getUserLocation
} from '../../utils';

import { RootStoreHelper, NotificationStoreHelper, AuthStoreHelper } from '../../mixins';

import { map, pairwise, takeUntil, tap } from 'rxjs/operators';
import { pluckAndStartWatch } from '../../operators';
import { Subject } from 'rxjs';
import { Destroyed } from '../../decorators';
import {
    getBoundsFromPosition,
    createInfo,
    mouseoutEvent,
    mouseoverEvent,
    mouseClickEvent,
    rightClickEvent,
    initMapCenter,
    onContextMenu,
    onMouseDown,
} from './index';
import AddPoint from './AddPoint.vue';

import DeleteConfirmation from '../../../tracking/components/Geofences/DeleteConfirmation.vue';
import Loading from 'vue-loading-overlay';
import { MarkStateStore } from '../../../tracking/components/Geofences/marks.state';
import { TrackingService } from '../../api';
import { geofencePatchError, geofenceReprocessMsg, geofenceSuccessPatchMsg, getGeofenceAlertForDeletion, getGeofenceAlertForEdition, getPointOfInterestAlertForDeletion, getSingleGeofenceAlertForDeletion } from '../../../tracking/utils';
import { overchargedTrackingColor } from '../../../norms/utils';
import { JOURNEY_OT_LOAD_STATE } from '../../../journeys/utils';
import { getDefaultMarker } from '../../../tracking/map-markers';
import { SvgTrackingIcons } from '../../../tracking/icons';
import { attachMarkerListeners, getGeofenceInfo, getInfoForLastReport, getPointsOfInterestInfo, pointOfInterestInfoContent } from '../../../tracking/map-markers-infos';
const MAP_TYPE_HYBRID = 'hybrid';
const MAP_TYPE_ROAD_MAP = 'roadmap';

@Component({
    components: {
        AddGeoFence,
        DrawRoutes,
        MapLoader,
        AddPoint,
        DeleteConfirmation,
        DrawVisualizations,
        ContextMenu,
        Loading
    }
})
export default class Map extends Mixins(RootStoreHelper, NotificationStoreHelper, AuthStoreHelper) {
    @Prop() markers: Marker[];
    @Prop() stopMarkers: object;
    @Prop({default: false}) dtcsAreVisible: boolean;
    @Prop({default: false}) showDtcsInMap: boolean;
    @Prop({default: false}) expandedPanel: boolean;
    @Prop({default: false}) mapLoading: boolean;
    @Prop() historicalDtcFailures: object;
    @Prop() historicalMarkers: MarkerVehicleHistoricalUUID[];
    @Prop() markersTravel: Marker[];
    @Prop() polygons: Point[];
    @Prop() showLabel: boolean;
    @Prop({ default: false }) isTravelDisplay: boolean;
    @Prop() playbackState: string;
    @Prop() playbackSpeed: number;
    @Prop() visualizationApply: VisualizationInfo;
    @Prop() addLegend: Method<LegendMap, void>;
    @Prop() setLegend: Method<LegendMap | null, void>;
    @Prop() zoom: number;
    @Prop() pointsOfInterest: PointsOfInterest[];
    @Prop() geoFences: Geofence[];
    @Prop() statsPanelOpen: boolean;
    @Prop() mapClientHeight: number;
    @Prop() heightStatsPanel: number;
    @Prop() loadingCursor: boolean;
    @Prop() geoFencesStore: MarkStateStore<Geofence>;
    @Prop() pointsStore: MarkStateStore<PointsOfInterest>;
    @Prop() geofenceTypes: any;
    @Prop() boundsAreCero: boolean;
    forceZoomAndCenter: boolean = true;
    markersMap: google.maps.marker.AdvancedMarkerElement[] = [];
    contextMenuItem: any = [];
    rightClickEvt: any = null;
    showContextMenu: boolean = false;
    listenerInfoWindows: any[] = [];
    tempInfoWindows: any[] = [];
    unSubscribe$: Subject<void> = new Subject<void>();
    infos: Record<string, PlayBackInfo> = {};
    timesStamp = new Set<string>();
    currentTimeStamp: string | undefined = undefined;
    timesStampIterator: string[] = [];
    countDrawRoutesTimeStamp: number = 0;
    disableListeners: boolean = false;
    timeOutDisableListener: any = null;
    menuBox: any = null;
    menuDisplayed: any = false;
    userHasZoomed: boolean = false;
    defaultLegend: LegendMap = {
        [TypeVehicleState.OFF]: {
            color: off,
            styles: {}
        },
        [TypeVehicleState.CONTACT]: {
            color: contact,
            styles: {}
        },
        [TypeVehicleState.MODERATING]: {
            color: moderating,
            styles: {}
        },
        /*[TypeVehicleState.MODERATING_WITHOUT_PTO]: moderating,
            [TypeVehicleState.MODERATING_WITH_PTO]: moderating,*/
        [TypeVehicleState.ON]: {
            color: on_driving_working,
            styles: {}
        },
        /*[TypeVehicleState.DRIVING]: on_driving_working,
            [TypeVehicleState.DRIVING_WITHOUT_CRUISE_CONTROL]: on_driving_working,
            [TypeVehicleState.DRIVING_WITH_CRUISE_CONTROL]: on_driving_working,
            [TypeVehicleState.WORKING]: on_driving_working*/
        [TypeVehicleState.OUTDATED]: {
            color: outdated,
            styles: {}
        },
        [TypeVehicleState.OVERCHARGED]: {
            color: white,
            styles: {
                'border': `1.5pt solid ${overchargedTrackingColor}`,
                'border-radius': `20px`
            }
        }
    };
    pointsOfInterestIDS: ElementId[] = [];
    geoFenceIDS: GeofenceElement[] = [];
    infoPointsIDS: InfoWindowID[] = [];
    infoGeoFencesIDS: InfoWindowID[] = [];
    visibleMenu: boolean = false;
    editPoint: boolean = false;
    positionX: number = 380;
    positionY: number = 100;
    addPointLat: number = 0;
    addPointLng: number = 0;

    editPointDescription: string = '';
    editGeofenceChoice: number = 0;
    editGeoFenceDescription: string = '';
    tmpAddPointMarker: google.maps.marker.AdvancedMarkerElement| null = null;
    listenerAddPoint: any = null;
    listenerEditPoint: any = null;
    listenerAddGeoFence: any = null;
    listenerEditGeoFence: any = null;
    pointId: number | string = '';
    geoFenceId: number | string = '';
    pointToEdit: PointsOfInterest | null = null;
    visibleGeoFenceMenu: boolean = false;
    editGeoFence: boolean = false;
    tmpPolygons: google.maps.Polygon[] = [];
    geoFenceToEdit: Geofence | null = null;
    unSelectedColor = trackingUnselectedColor;
    boundsCentered: google.maps.LatLngBounds | null = null;
    selectingVehicles: boolean = false;
    vehiclesSelected: any[] = [];
    variables: any;
    summaryDeleteConfirmation: string[] = [];
    deleteConfirmationBody: string = '';
    alertPatchGeofenceBodyMsg: string = '';
    alertGeofenceConfirmation: boolean = false;


    //popup right click menu
    clickedPoI: PointsOfInterest;
    clickedGeofence: Geofence;
    clickedElementIsPoI: boolean = false;
    showEditMenu: boolean = false;
    editMenuX: number = 0;
    editMenuY: number = 0;
    confirmationDelete: boolean = false;
    previouslySelectedGeofences: Geofence[] = [];
    previouslySelectedPoints: PointsOfInterest[] = [];

    //ctrl mac listeners
    isMac: boolean = false;
    webkit: boolean = false;
    mozilla: boolean = false;
    opera: boolean = false;
    kC: string = '';

    get checkTemporalPolygons():boolean {
        if(this.geoFenceId !== '' && this.geoFenceIDS.length > 0){
            //si edito una geocerca que tiene poligonos > OK
            return true
        }
        //si no tiene poligonos checkeo los temporales
        return polygonsAreValid(this.tmpPolygons);
    }



    get canManipulateGeofences(): boolean{
        return this.$_checkPrivilegesEqual(PRIVILEGE_KEYS.ONLY_LAST_REPORT, PRIVILEGE_TYPES.NONE)
    }
   

    sayWho() {
        let ua = navigator.userAgent,
            tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { browser: 'IE', version: tem[1] || '' };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            //if(tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            if (tem != null) return { browser: tem.slice(1)[0].replace('OPR', 'Opera'), version: tem.slice(1)[1] };
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return { browser: M[0], version: M[1] };
    }

    @Emit()
    resetDtcFailsToggle() {}

    //polygon deletion
    clickedElementIsTmpPolygon: boolean = false;
    tmpPolygonsDeleted: number[] = [];
    clickedTmpPolygon: number = 0;
    clickedPolygon: number;
    zoomTimeout: any = null;
    isMeasuring: boolean = false;

    getTrackingColor(index: number): string {
        return trackingColors[index];
    }

    resetForceZoomAndCenter() {
        this.forceZoomAndCenter = true;
    }

    cancelForceZoomAndCenter() {
        this.forceZoomAndCenter = false;
    }

    closeContextMenu(){
        this.showContextMenu = false;
    }

    onMeasureStart(){
        this.isMeasuring = true;
    }

    onMeasureEnd(){
        this.isMeasuring = false;
    }

    elemenToOpen(element){        
        this.$emit('open-actual-state-panel', element);
    }

    addCtrlListeners() {
        this.webkit = this.sayWho().browser === 'Chrome' || this.sayWho().browser === 'Safari';
        this.mozilla = this.sayWho().browser === 'Firefox';
        this.opera = this.sayWho().browser === 'Opera';
        window.addEventListener('keydown', event => {
            let kC = event.keyCode;
            if (
                event.key === 'Control' ||
                ((this.webkit || this.opera) && (kC === 91 || kC === 93)) ||
                (this.mozilla && kC === 224)
            ) {
                this.selectingVehicles = true;
            }
        });

        window.addEventListener('keyup', event => {
            let kC = event.keyCode;
            if (
                event.key === 'Control' ||
                ((this.webkit || this.opera) && (kC === 91 || kC === 93)) ||
                (this.mozilla && kC === 224)
            ) {
                this.selectingVehicles = false;
                if(this.vehiclesSelected.length > 0){
                    EventBus.$emit(TypeEventBus.SELECT_VEHICLES_FROM_MAP, this.vehiclesSelected);
                    this.vehiclesSelected = [];
                }
            }
        });

        window.addEventListener(
            'blur',
            event => {
                this.selectingVehicles = false;
                this.vehiclesSelected = [];
            },
            false
        );
    }
    

    mounted() {
        this.addCtrlListeners();
        const historicalMarkers$ = this.$watchAsObservable('historicalMarkers');
        const markers$ = this.$watchAsObservable('markers');
        const showLabel$ = this.$watchAsObservable('showLabel');
        const playbackState$ = this.$watchAsObservable('playbackState');
        const pointsOfInterest$ = this.$watchAsObservable('pointsOfInterest');
        const geoFences$ = this.$watchAsObservable('geoFences');
        const loadingCursor$ = this.$watchAsObservable('loadingCursor');
        historicalMarkers$
            .pipe(
                pluckAndStartWatch([]),
                tap(markersUUID => this.selectTimeStampEffect(markersUUID)),
                tap(() => this.clearPlayBackInfoEffect()),
                tap(markersUUID => {
                    if (!hasElements(markersUUID)) {
                        this.setZoomAndCenterEffect([]);
                        this.changeBoundsCentered();
                    }
                }),
                takeUntil(this.unSubscribe$)
            )
            .subscribe();
        markers$
            .pipe(
                pluckAndStartWatch([]),
                tap(() => this.hideAndDeleteAllMarkersEffect()),
                tap(() => this.hideAndDeleteListenerInfoWindowsEffect()),
                tap(() => this.hideAndDeleteTempInfoWindowsEffect()),
                tap((markers: Marker[]) => this.getMarkersMapFromMarkersEffect(markers)),
                tap(() => this.showAllMarkersEffect()),
                tap(() => this.showTempInfoWindowsEffect(this.showLabel)),
                // map(() => this.getPositionsFromMarkersMap()),
                tap((positions: Point[]) => {
                    if (hasElements(positions) && this.forceZoomAndCenter) {
                        setTimeout(() => {
                            this.setZoomAndCenterEffect(positions);
                            this.changeBoundsCentered();
                            this.cancelForceZoomAndCenter();
                            this.showDefaultLegend();
                        }, 500);
                    }
                }),
                takeUntil(this.unSubscribe$)
            )
            .subscribe();

        pointsOfInterest$
            .pipe(
                pluckAndStartWatch([]),
                pairwise(),
                map((pointsArray: [PointsOfInterest[], PointsOfInterest[]]) =>
                    this.searchMissingAndAddedPoints(pointsArray[0], pointsArray[1])
                ),
                tap((search: SearchOfInterest) => {
                    const clean: (number | string)[] = this.cleanElements<PointsOfInterest>(
                        search.missing,
                        this.pointsOfInterestIDS,
                        this.infoPointsIDS,
                        POINT_OF_INTEREST_KEY
                    );
                    this.pointsOfInterestIDS = this.pointsOfInterestIDS.filter(
                        point => !clean.find(cleanId => cleanId.toString() === point.id.toString())
                    );
                    this.infoPointsIDS = this.infoPointsIDS.filter(
                        point => !clean.find(cleanId => cleanId.toString() === point.id.toString())
                    );
                }),
                tap((search: SearchOfInterest) => this.addPoints(search.added)),
                takeUntil(this.unSubscribe$)
            )
            .subscribe();

        geoFences$
            .pipe(
                pluckAndStartWatch([]),
                pairwise(),
                map((geofences: [Geofence[], Geofence[]]) =>
                    this.searchMissingAndAddedGeoFences(geofences[0], geofences[1])
                ),
                tap((search: SearchOfGeoFence) => {
                    const clean: (number | string)[] = this.cleanElements<Geofence>(
                        search.missing,
                        this.geoFenceIDS,
                        this.infoGeoFencesIDS,
                        GEO_FENCE_KEY
                    );
                    this.geoFenceIDS = this.geoFenceIDS.filter(
                        geo => !clean.find(cleanId => cleanId.toString() === geo.id.toString())
                    );
                    this.infoGeoFencesIDS = this.infoGeoFencesIDS.filter(
                        geo => !clean.find(cleanId => cleanId.toString() === geo.id.toString())
                    );
                }),
                tap((search: SearchOfGeoFence) => this.addGeoFence(search.added)),
                takeUntil(this.unSubscribe$)
            )
            .subscribe();

        showLabel$
            .pipe(
                pluckAndStartWatch(false),
                tap(showLabel => this.showTempInfoWindowsEffect(showLabel)),
                takeUntil(this.unSubscribe$)
            )
            .subscribe();

        playbackState$
            .pipe(
                pluckAndStartWatch(PlaybackState.UNDEFINED),
                tap(state => {
                    if (state === PlaybackState.STOP || state === PlaybackState.UNDEFINED) {
                        this.selectTimeStampEffect(this.historicalMarkers);
                        this.timeStampInfo(undefined);
                    }
                }),
                takeUntil(this.unSubscribe$)
            )
            .subscribe();

        loadingCursor$
            .pipe(
                pluckAndStartWatch(false),
                tap(value => {
                    if (this.googleMap) {
                        if (value) {
                            this.googleMap.setOptions({ draggableCursor: 'progress' });
                        } else {
                            this.setDefaultCursor();
                        }
                    }
                }),
                takeUntil(this.unSubscribe$)
            )
            .subscribe();
    }

    @Emit()
    changeBoundsCentered() {
        return this.boundsCentered;
    }

    addListenersForLastReportMarker(
        marker: google.maps.marker.AdvancedMarkerElement,
        infoWindow: google.maps.InfoWindow
    ){
         let self = this;
        //right click event
        attachMarkerListeners(
            marker, 
            infoWindow,
            'contextmenu',
            (e: MouseEvent) => {
                    let vehicleId = marker['vehicle_id'];
                    self.rightClickEvt = null;
                    self.contextMenuItem = [];
                    self.pushcontextMenuItems(marker, vehicleId)
                    self.rightClickEvt = e;
            }
        )


        //mouseover mouseout event
         attachMarkerListeners(
            marker, 
            infoWindow
        )


        
        //click event
        attachMarkerListeners(
            marker, 
            infoWindow,
            mouseClickEvent,
            (e: MouseEvent) => {
                // console.log("click marker vehicle id", marker['vehicle_id'])
                let vehicleId = marker['vehicle_id'];
                if (vehicleId) {
                    if (self.selectingVehicles) {
                        //user clicked a vehicle while pressing ctrl. Either select it or unselect it depending on previous state
                        //if vehicle is selected a red border
                         self.toggleRedBorderToSelectedMarker(marker, self.addOrRemoveSelectedVehicle(vehicleId));
                    } else {
                        //user clicked a vehicle without pressing ctrl, emit petition to filter it
                        EventBus.$emit(TypeEventBus.SELECT_VEHICLES_FROM_MAP, [vehicleId]);
                        self.vehiclesSelected = [];
                    }
                }
            }
        )
    }

    setCenter(positions: Point[]): void {
        if (this.googleMap) {
            this.centerPositions(positions);
        }
    }

    centerPositions(positions){
        if (hasElements(positions)) {
                let bound = getBoundsFromPosition(positions, this.statsPanelOpen, this.mapClientHeight);
                this.boundsCentered = bound;
                if (positions.length === 1) {
                    if(this.$_getOpenStatsPanel){
                        this.googleMap.fitBounds(bound, 300);
                        this.googleMap.setZoom(10);
                        this.googleMap.panBy(0,150);
                    }else{
                        this.googleMap.fitBounds(bound);
                        this.googleMap.setZoom(10);
                    }
                }else{
                    this.googleMap.setCenter(bound.getCenter());
                    this.googleMap.fitBounds(bound);
                }
                
            } 
    }

    setZoomAndCenterEffect(positions: Point[]) {
        positions = getPositionsFiltered(positions);
        if (this.googleMap) {
            this.addListenersContextMenu();
            this.centerPositions(positions);
            this.enableListenersEffect();
        }
    }


    addListenersContextMenu(){
        let self = this;
        google.maps.event.addListener(this.googleMap, 'zoom_changed', event => {
            clearTimeout(this.zoomTimeout);
            this.zoomTimeout = setTimeout(() => { //prevent zoom_changed running twice by default
                self.changeUserHasZoomed(true);
                self.closeContextMenu();
            }, 100)
        });
        google.maps.event.addListener(this.googleMap, 'drag', event => {
            this.closeContextMenu();
        });
    }

    setZoomAndCenterMergeMap(): void {
        this.setZoomAndCenterEffect(this.getPositionsFromMarkersMap());
        this.changeBoundsCentered();
    }

    get getItemsContextMenu(){
        return this.contextMenuItem
    }

    get watchRightClickEvent(){
        return this.rightClickEvt;
    }

    get mapLoader(): HTMLFormElement {
        return this.$refs.mapLoader as HTMLFormElement;
    }

    get googleMap(): google.maps.Map {
        return this.mapLoader.mapObject;
    }

    get googleApi(): any {
        return this.mapLoader.googleObject;
    }

    @Emit()
    showLabelEvent(value: boolean) {
        return value;
    }

    initZoom = 7;
    //TODO: make this a configurable variable

    mapConfig: any = {
        zoom: this.initZoom,
        minZoom: 4,
        center: initMapCenter,
        mapTypeId: MAP_TYPE_ROAD_MAP,
        mapId: 'TRAVEL_MAP',
        // restriction: {
        //     latLngBounds: latinamericaBounds,
        //     strictBounds: true
        // }
    };
    selectedGeofence: number = 9999;

    setMapOnAll(map: any): void {
        for (let i = 0; i < this.markersMap.length; i++) {
            this.markersMap[i].map = map;
        }
    }

    setMapTye(value: google.maps.MapTypeId): void {
        this.googleMap.setMapTypeId(value.toString());
    }

    clearMarkersMap(): void {
        this.setMapOnAll(null);
    }

    createDefaultMarker(point: Point): google.maps.marker.AdvancedMarkerElement {
        return getDefaultMarker(point)
    }


    createDefaultPolygon(
        positions: Point[] | undefined | null,
        editable: boolean,
        draggable: boolean
    ): google.maps.Polygon {
        const polygonOptions: google.maps.PolygonOptions = {
            strokeColor: 'rgba(0,0,0,0.59)',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: 'rgba(101,114,223,0.48)',
            fillOpacity: 1,
            draggable,
            editable,
            geodesic: false,
            map: this.googleMap
        };
        let newPolygon = new google.maps.Polygon(polygonOptions);
        if (positions) {
            newPolygon.setPath(positions);
        }
        return newPolygon;
    }

    createMarker(marker: Marker): google.maps.marker.AdvancedMarkerElement {
        /* Creo Marcador para el "Ahora" */
        let vehicleIsOverloaded = marker && marker.infoState && marker.infoState.work_order_load_state == JOURNEY_OT_LOAD_STATE || false;
        let markerColor = marker && marker.infoState && marker.infoState.color ? marker.infoState.color : ColorsList.gray;
        let markerRotation = marker && marker.icon && marker.icon.rotation ? marker.icon.rotation : 0;
        let baseMarker = getDefaultMarker(marker);
        baseMarker.title = '',
        baseMarker.zIndex = 10;
        baseMarker['rotation'] = markerRotation;
        baseMarker['color'] = markerColor;
        baseMarker['is_charged'] = vehicleIsOverloaded;
        baseMarker.content = customSvgForMarker(SvgTrackingIcons.ActualStateIcon(markerColor, vehicleIsOverloaded, markerRotation, false))

        return baseMarker;
        
    }

    addOrRemoveSelectedVehicle(id: string | number) {
        let selected = false;

        for (let i = this.vehiclesSelected.length - 1; i >= 0; i--) {
            if (this.vehiclesSelected[i] === id) {
                selected = true;
                this.vehiclesSelected.splice(i, 1);
            }
        }

        let toAdd = !selected && this.vehiclesSelected.length < 3;

        if (!selected && this.vehiclesSelected.length == 3) {
            if (this.vehiclesSelected.length == 3) {
                this.$_showMaxVehiclesSelected('Solo puede seleccionar hasta 3 vehículos.');
            }
        }

        if (toAdd) {
            this.vehiclesSelected.push(id);
        }

        return toAdd;
    }

    toggleRedBorderToSelectedMarker(
        marker:google.maps.marker.AdvancedMarkerElement,
        isSelected: boolean
    ) {
        marker.content = customSvgForMarker(SvgTrackingIcons.ActualStateIcon(
            marker['color'], 
            marker['is_charged'],  
            marker['rotation'],
            isSelected
        ))
    }

    get isMdpUser(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.MDP] == true;
    }

    getMarkersMapFromMarkersEffect(markers: Marker[]): void {
        for (let i = 0; i < markers.length; i++) {
            let marker = markers[i];
           
            let googleMarker = this.createMarker(marker);
             if(marker && marker.info && marker.info.id){
                googleMarker['vehicle_id'] = marker.info.id
            }  
            
            this.markersMap.push(googleMarker);
            

            for (let v = 0; v < this.vehiclesSelected.length; v++) {
                if (marker && marker.info && marker.info.id) {
                    if (marker.info.id == this.vehiclesSelected[v]) {
                        this.toggleRedBorderToSelectedMarker(this.markersMap[i], true)
                    }
                }
            }
           
            // console.log("listener markers for last report", marker)
            this.listenerInfoWindows.push(getInfoForLastReport(marker, this.isMdpUser));
            
            this.addListenersForLastReportMarker(
                this.markersMap[i],
                this.listenerInfoWindows[i]
            );
        }
    }

    hideAndDeleteAllMarkersEffect() {
        this.clearMarkersMap();
        this.deleteAllListenerToAllMarker(this.markersMap);
        this.markersMap = [];
    }

    deleteAllListenerToAllMarker(markers: any[]) {
        for (let i = 0; i < markers.length; i++) {
            google.maps.event.clearInstanceListeners(markers[i]);
        }
    }

    showAllMarkersEffect() {
        this.setMapOnAll(this.googleMap);
    }

    getPositionsFromMarkersMap(): Point[] {
        return this.markersMap
        .filter(m => m.position instanceof google.maps.LatLng)
        .map(m => ({ lat: (m.position as google.maps.LatLng).lat(), lng: (m.position as google.maps.LatLng).lng() }));
    }

    closeInfoWindows(infoWindows: any[]): void {
        for (let i = 0; i < infoWindows.length; i++) {
            infoWindows[i].close();
        }
    }

    hideAndDeleteListenerInfoWindowsEffect() {
        this.closeInfoWindows(this.listenerInfoWindows);
        this.listenerInfoWindows = [];
    }

    hideAndDeleteTempInfoWindowsEffect() {
        this.closeInfoWindows(this.tempInfoWindows);
        this.tempInfoWindows = [];
    }

    showTempInfoWindowsEffect(showLabel: boolean): void {
        if (showLabel) {
            for (let i = 0; i < this.markers.length; i++) {
                this.tempInfoWindows.push(createInfo(this.markers[i]));
                this.tempInfoWindows[i].open(this.googleMap, this.markersMap[i]);
            }
        } else {
            this.hideAndDeleteTempInfoWindowsEffect();
        }
    }

    @Emit()
    playBackInfos(info: Record<string, PlayBackInfo>) {}

    handlePlayBackInfo(id: string, info: PlayBackInfo): void {
        this.infos = {
            ...this.infos,
            [id]: info
        };
        this.playBackInfos(this.infos);
    }

    clearPlayBackInfoEffect(): void {
        this.infos = {};
        this.playBackInfos(this.infos);
    }

    clearTimestamp(): void {
        this.timesStamp.clear();
        this.timesStampIterator = [];
        this.countDrawRoutesTimeStamp = 0;
    }

    pushContextMenuItemsForSmartwayUsers(marker, vehicleId){
        this.contextMenuItem.push(
            {
                title: 'Estado actual',
                openElement: {
                    ref: 'statsPanel',
                    data: marker
                },
                disabled: false,
            },
            {
                disabled: false,
                title: 'Ver Vehículo',
                link: {
                    path: '/settings/vehicles/' + vehicleId,
                    target: '_blank'
                }
            }
        );
    }

    pushContextMenuItemsForNormalUsers(marker){
        this.contextMenuItem.push(
            {
                disabled: false,
                title: 'Estado actual',
                openElement: {
                    ref: 'statsPanel',
                    data: marker
                }
            },
        );
    }



    pushcontextMenuItems(marker, vehicleId){
        if (this.$_getSmartwayMember) {
            this.pushContextMenuItemsForSmartwayUsers(marker, vehicleId)
        } else {
            this.pushContextMenuItemsForNormalUsers(marker)
        }

    }

    selectTimestamps(markersUUID: MarkerVehicleHistoricalUUID[]): void {
        for (let i = 0; i < markersUUID.length; i++) {
            for (let j = markersUUID[i].start; j < markersUUID[i].end; j++) {
                let marker = markersUUID[i].markers[j];
                if (marker && marker.infoState && marker.infoState.timestamp) {
                    this.timesStamp.add(marker.infoState.timestamp);
                }
            }
        }
        this.timesStamp = new Set(
            Array.from(this.timesStamp).sort(
                (a, b) => getDateFromDateFormatApi(a).getTime() - getDateFromDateFormatApi(b).getTime()
            )
        );
        this.timesStampIterator = [...this.timesStamp];
    }

    selectTimeStampEffect(markersUUID: MarkerVehicleHistoricalUUID[]): void {
        this.clearTimestamp();
        this.selectTimestamps(markersUUID);
        this.nextTimeStamp();
    }

    @Emit()
    timeStampInfo(timeStamp: string | undefined) {}

    nextTimeStamp(): void {
        this.currentTimeStamp = this.timesStampIterator.shift();
        this.timeStampInfo(this.currentTimeStamp);
    }

    handleNextTimeStamp(): void {
        this.countDrawRoutesTimeStamp = this.countDrawRoutesTimeStamp + 1;
        if (this.countDrawRoutesTimeStamp <= this.timesStamp.size) {
            this.nextTimeStamp();
        } else {
            this.setUndefinedState();
        }
    }

    disableListenersEffect(): void {
        if (this.timeOutDisableListener) {
            clearTimeout(this.timeOutDisableListener);
            this.timeOutDisableListener = null;
        }
        this.disableListeners = true;
    }

    enableListenersEffect(): void {
        if (this.timeOutDisableListener) {
            clearTimeout(this.timeOutDisableListener);
            this.timeOutDisableListener = null;
        }
        this.timeOutDisableListener = setTimeout(() => {
            this.disableListeners = false;
        }, 1000);
    }

    @Emit()
    setUndefinedState() {}

    @Destroyed
    unSubscribe(): void {
        this.unSubscribe$.next();
        this.unSubscribe$.complete();
    }

    showDefaultLegend() {
        this.setLegend(this.defaultLegend);
    }


    
    getGeofenceTypeName(type) {
        let geocercasValues:any = Object.values(this.$_getGeofencesTypes);
        if(type){
            for(let i=0; i<geocercasValues.length; i++){
                if(geocercasValues[i].id === type){
                    return geocercasValues[i].value
                }
            }
        }

        return 'Genérica'
    }

    searchMissingAndAddedPoints(oldValue: PointsOfInterest[], newValue: PointsOfInterest[]): SearchOfInterest {
        const missingPoints = this.searchMissing<PointsOfInterest>(oldValue, newValue, POINT_OF_INTEREST_KEY);
        const addedPoints = this.searchAddedElement<PointsOfInterest>(
            newValue,
            this.pointsOfInterestIDS,
            POINT_OF_INTEREST_KEY
        );
        return {
            added: addedPoints,
            missing: missingPoints
        };
    }

    searchMissing<T>(oldValue: T[], newValue: T[], idKey: string): T[] {
        let missing: T[] = [];
        for (let i = 0; i < oldValue.length; i++) {
            if (!newValue.find(element => element[idKey].toString() === oldValue[i][idKey].toString())) {
                missing.push(oldValue[i]);
            }
        }
        return missing;
    }

    searchAddedElement<T>(newValue: T[], arrayToFind: ElementId[], idKey: string): T[] {
        let added: T[] = [];
        for (let i = 0; i < newValue.length; i++) {
            if (!arrayToFind.find(point => point.id.toString() === newValue[i][idKey].toString())) {
                added.push(newValue[i]);
            }
        }
        return added;
    }

    addPoints(added: PointsOfInterest[]): void {
        for (let i = 0; i < added.length; i++) {
            const googleMarker: google.maps.marker.AdvancedMarkerElement = this.createDefaultMarker(added[i].point);
            googleMarker.content = customPinElement({
                scale: 0.7, 
                backgroundColor: ColorsList.red_google_marker_light,
                gliphColor: ColorsList.red_google_marker_dark
            });
            (googleMarker.content as HTMLElement).style.opacity = '0.9';


            googleMarker.map = this.googleMap;
            this.pointsOfInterestIDS.push({
                element: googleMarker,
                id: added[i].point_of_interest_id
            });

            const googleWindow = getPointsOfInterestInfo(added[i]);
            this.infoPointsIDS.push({
                id: added[i].point_of_interest_id,
                window: googleWindow
            });

            this.attachListenerForPointOfInterest(
                googleMarker,
                googleWindow,
                added[i]
            )
        }
    }

    attachListenerForPointOfInterest(
        marker: google.maps.marker.AdvancedMarkerElement,
        infoWindow: google.maps.InfoWindow,
        pointsOfInterest: PointsOfInterest
    ){
        let self = this;
        //mouseover / mouseout
        attachMarkerListeners(
            marker, 
            infoWindow
        )

        //right click
        attachMarkerListeners(
            marker, 
            infoWindow,
            onMouseDown,
            (e: MouseEvent) => {
                if(e.which == 3){
                    self.clickedPoI = pointsOfInterest;
                    self.clickedElementIsPoI = true;
                    self.openMenu(event);
                }
            }
        )
    }

    addGeoFence(added: Geofence[]): void {
        for (let i = 0; i < added.length; i++) {
            const polygons: google.maps.Polygon[] = [];

            for (let j = 0; j < added[i].polygons.length; j++) {
                polygons.push(this.createDefaultPolygon(added[i].polygons[j].points, false, false));
            }

            this.geoFenceIDS.push({
                element: polygons,
                id: added[i].geofence_id
            });

            this.addGeoFenceInfo(added[i], polygons);
        }
    }

    addGeoFenceInfo(geoFence: Geofence, polygons: google.maps.Polygon[]): void {
        const googleWindow = getGeofenceInfo(geoFence, this.getGeofenceTypeName(geoFence.geofence_type));
        this.infoGeoFencesIDS.push({
            id: geoFence.geofence_id,
            window: googleWindow
        });
        for (let k = 0; k < polygons.length; k++) {
            google.maps.event.addListener(polygons[k], mouseoverEvent, event => {
                if(this.geoFenceToEdit == null){
                    googleWindow.setPosition(event.latLng);
                    googleWindow.open(this.googleMap, polygons[k]);
                }
            });

            google.maps.event.addListener(polygons[k], 'rightclick', event => {
                this.clickedGeofence = geoFence;
                this.clickedElementIsPoI = false;
                this.clickedPolygon = k;
                this.openMenu(event);
            });

            google.maps.event.addListener(polygons[k], mouseoutEvent, () => {
                googleWindow.close();
            });
        }
    }

    openMenu(e) {
        let keys = Object.keys(e);
        for (let i = 0; i < keys.length; i++) {
            if (MouseEvent.prototype.isPrototypeOf(e[keys[i]])) {
                this.showEditMenu = false;
                this.editMenuX = e[keys[i]].clientX;
                this.editMenuY = e[keys[i]].clientY;
                this.$nextTick(() => {
                    this.showEditMenu = true;
                });
            }
        }
    }

    hideClicked() {
        if (this.clickedElementIsPoI) {
            this.pointsStore.removeSelected(this.clickedPoI, 'point_of_interest_id');
        } else {
            this.geoFencesStore.removeSelected(this.clickedGeofence, 'geofence_id');
        }
    }

    editGeofenceOrPointFromMap() {
        if (this.clickedElementIsPoI) {
            this.previouslySelectedPoints = this.pointsStore.getSelected();
            this.previouslySelectedGeofences = this.geoFencesStore.getSelected();
            this.pointsStore.setSelected([this.clickedPoI]);
            this.geoFencesStore.setSelected([]);
            this.waitForEditPoint(this.clickedPoI);
        } else {
            this.previouslySelectedPoints = this.pointsStore.getSelected();
            this.previouslySelectedGeofences = this.geoFencesStore.getSelected();
            this.geoFencesStore.setSelected([this.clickedGeofence]);
            this.pointsStore.setSelected([]);
            this.waitForEditGeoFence(this.clickedGeofence);
        }
    }

    updateSummaryDeleteConfirmation(value: string[]){
        this.summaryDeleteConfirmation = value;
    }

    updateDeleteConfirmationBody(pointToDelete){
        if(this.clickedElementIsPoI){
            this.deleteConfirmationBody = getPointOfInterestAlertForDeletion([pointToDelete]);
        }else{
            this.deleteConfirmationBody = getSingleGeofenceAlertForDeletion(pointToDelete);
        }
    }

    handleDelete() {
        let pointToDelete = this.clickedElementIsPoI ? this.clickedPoI : this.clickedGeofence;
        this.updateDeleteConfirmationBody(pointToDelete);
    }

    deleteElement(action: boolean) {
        this.confirmationDelete = false;
        if (action) {
            if (this.clickedElementIsPoI) {
                TrackingService.deletePointsOfInterest([this.clickedPoI.point_of_interest_id.toString()])
                    .then(response => {
                        if ((response && response['status'] === 200) || response['status'] === 204) {
                            this.$_showDeleteGeofences('Elemento eliminado correctamente.');
                            this.pointsStore.removeSelected(this.clickedPoI, 'point_of_interest_id');
                            this.pointsStore.removeElements([this.clickedPoI], 'point_of_interest_id');
                        } else {
                            this.$_errorDeleteGeofences('Problema eliminando');
                        }
                    })
                    .catch(error => {
                        this.$_catchLoadingDialog({
                            response: error.response.data || {},
                            alternative_msg: 'No se pudieron eliminar los puntos de interes'
                        })
                    });
            } else {
                TrackingService.deleteGeofences([this.clickedGeofence.geofence_id])
                    .then(response => {
                        if ((response && response['status'] === 200) || response['status'] === 204) {
                            this.$_showDeleteGeofences('Elemento eliminado correctamente.');
                            this.geoFencesStore.removeSelected(this.clickedGeofence, 'geofence_id');
                            this.geoFencesStore.removeElements([this.clickedGeofence], 'geofence_id');
                        } else {
                            this.$_errorDeleteGeofences('Problema eliminando');
                        }
                    })
                    .catch(error => {
                        this.$_catchLoadingDialog({
                            response: error.response.data || {},
                            alternative_msg: 'No se pudieron eliminar las geocercas'
                        })
                    });
            }
        }
    }

    handleClickDeletePolygon() {
        if (this.clickedElementIsTmpPolygon) {
            let actualPosition = this.clickedTmpPolygon;
            this.tmpPolygons[actualPosition].setMap(null);
        } else {
            const elements: google.maps.Polygon[] = this.geoFenceIDS[0].element as google.maps.Polygon[];
            this.geoFenceIDS.splice(0, 1);
            elements[this.clickedPolygon].setMap(null);
        }
    }

    getGoogleMapsPolygonsFromPolygons(polygons: Polygon[]) {
        let gmapsPolygons: google.maps.Polygon[] = [];
        for (let p = 0; p < polygons.length; p++) {
            let polygon = this.getNewPolygon();
            let path: google.maps.MVCArray<google.maps.LatLng> = polygon.getPath();
            for (let i = 0; i < polygons[p].points.length; i++) {
                path.push(new google.maps.LatLng({ lat: polygons[p].points[i].lat, lng: polygons[p].points[i].lng }));
            }
            gmapsPolygons.push(polygon);
        }
        return gmapsPolygons;
    }

    buildGeoFence(polygons: google.maps.Polygon[]): GeofenceAdd {
        let resultPolygons: PolygonComplete[] = [];
        for (let i = 0; i < polygons.length; i++) {
            let paths: google.maps.MVCArray<google.maps.LatLng> = polygons[i].getPath();
            let points: any = [];
            paths.forEach(path => {
                points.push({ latitude: path.lat(), longitude: path.lng() });
            });
            if (points.length) {
                points.push(points[0]);
                resultPolygons.push({ points });
            }
            polygons[i].setMap(null);
        }
        return {
            geofence_type: this.selectedGeofence,
            description: this.clickedGeofence.description,
            polygons: resultPolygons
        };
    }

    editGeofence(): void {
        if (this.clickedGeofence.polygons.length == 0) {
            TrackingService.deleteGeofences([this.clickedGeofence.geofence_id])
                .then(response => {
                    if ((response && response['status'] === 200) || response['status'] === 204) {
                        if (response['data'] && response['data'].message) {
                            this.$_showDeleteGeofences(response['data'].message);
                        } else {
                            this.$_showDeleteGeofences('Geocerca eliminada correctamente.');
                        }
                    } else {
                        this.$_errorDeleteGeofences('Problema eliminando');
                    }
                })
                .catch(error => {
                    this.$_errorDeleteGeofences(error.message);
                });
        } else {
            if(
                this.clickedGeofence && 
                this.clickedGeofence.reports > 0 ||
                this.clickedGeofence.alarms > 0
            ){
                this.showGeofenceEditAlert(
                    this.clickedGeofence.reports,
                    this.clickedGeofence.alarms
                );
            }else{
                this.modifyGeofence();
            }
        }
    }

    showGeofenceEditAlert(totalReports: number, totalAlarms: number){
        /* 
            esta alerta se muestra si la geocerca esta asociada a algun reporte 
        */
        let geofenceAlertMessage = getGeofenceAlertForEdition(totalReports, totalAlarms);
        this.alertPatchGeofenceBodyMsg = geofenceAlertMessage;
    }

    modifyGeofence(){
        let geofenceToAdd = this.buildGeoFence(
            this.getGoogleMapsPolygonsFromPolygons(this.clickedGeofence.polygons)
        );
        TrackingService.patchGeofenceByCompany(geofenceToAdd, this.clickedGeofence.geofence_id as string)
            .then(response => {
                if (response['status'] === 200 || response['status'] === 204) {
                    this.handleEditGeoFence(this.clickedGeofence);
                    this.showAlertReprocessGeofence(response);
                } else {
                    this.$_errorAddPointOfInterest(geofencePatchError);
                }
            })
            .catch(error => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: geofencePatchError
                })
            });
    }

    showAlertReprocessGeofence(response){
        let msg = geofenceSuccessPatchMsg;
        // response['data']['reprocess'] = true
        if(response && response['data']['reprocess']){
            msg += ' <br>' + geofenceReprocessMsg
        }  
        this.$_showAddPointOfInterest(msg);
    }

    closeConfirmationGeofenceAlert(userConfirmedPatch: boolean){
        this.alertGeofenceConfirmation = false;
        this.alertPatchGeofenceBodyMsg = '';
        if(userConfirmedPatch){
            this.modifyGeofence();
        }
    }

    setDefaultCursor(): void {
        this.googleMap.setOptions({ draggableCursor: 'default' });
    }

    clearAddOrEditPointState(): void {
        this.visibleMenu = false;
        this.editPoint = false;
        this.editPointDescription = '';
        this.pointId = '';
        this.addPointLat = 0;
        this.addPointLng = 0;
        this.pointToEdit = null;
        this.clearTmpAddPointMarker();
        this.setDefaultCursor();
        this.pointsStore.setSelected(this.previouslySelectedPoints);
        this.geoFencesStore.setSelected(this.previouslySelectedGeofences);
    }

    clearAddOrEditGeoFenceState(): void {
        this.visibleGeoFenceMenu = false;
        this.editGeoFence = false;
        this.geoFenceToEdit = null;
        this.editGeofenceChoice = 0;
        this.editGeoFenceDescription = '';
        this.geoFenceId = '';
        this.clearTmpPolygons();
        this.setDefaultCursor();
        this.tmpPolygonsDeleted = [];
        this.pointsStore.setSelected(this.previouslySelectedPoints);
        this.geoFencesStore.setSelected(this.previouslySelectedGeofences);
        this.clickedElementIsTmpPolygon = false;
    }

    setPositionToPointsOfInterest(id: string | number, position: google.maps.LatLng): void {
        for (let i = 0; i < this.pointsOfInterestIDS.length; i++) {
            if (this.pointsOfInterestIDS[i].id === id) {
                (<google.maps.marker.AdvancedMarkerElement>this.pointsOfInterestIDS[i].element).position = position;
            }
        }
    }

    handleCancelPoint(point: PointsOfInterest | null): void {
        if (point) {
            this.setPositionToPointsOfInterest(
                point.point_of_interest_id,
                new google.maps.LatLng(point.point.lat, point.point.lng)
            );
        }
        this.clearAddOrEditPointState();
        this.addAndSelectPointOfInterest(null);
        this.editAndSelectPointOfInterest(null);
    }

    handleCancelGeoFence(geoFence: Geofence | null): void {
        if (geoFence) {
            this.setStateToGeoFence(geoFence.geofence_id, false, false);
            this.updateGeoFenceIDSGeoFence(geoFence);
        }
        this.clearAddOrEditGeoFenceState();
        this.addAndSelectGeoFence(null);
        this.editAndSelectGeoFence(null);
        this.setMapTye(google.maps.MapTypeId.ROADMAP);
    }

    handleAddPoint(point: PointsOfInterest | null): void {
        if (point) {
            this.clearAddOrEditPointState();
            this.addAndSelectPointOfInterest(point);
        }
    }

    handleAddGeoFence(geofence: Geofence | null): void {
        if (geofence) {
            this.clearAddOrEditGeoFenceState();
            const element: google.maps.Polygon[] = [];
            for (let i = 0; i < geofence.polygons.length; i++) {
                element.push(this.createDefaultPolygon(geofence.polygons[i].points, false, false));
            }
            if (element.length) {
                this.geoFenceIDS.push({
                    element,
                    id: geofence.geofence_id
                });
                this.addGeoFenceInfo(geofence, element);
                this.addAndSelectGeoFence(geofence);
            }
            this.setMapTye(google.maps.MapTypeId.ROADMAP);
        }
    }

    handleEditPoint(point: PointsOfInterest | null): void {
        if (point) {
            this.clearAddOrEditPointState();
            this.editAndSelectPointOfInterest(point);
            for (let i = 0; i < this.infoPointsIDS.length; i++) {
                if (this.infoPointsIDS[i].id === point.point_of_interest_id) {
                    this.infoPointsIDS[i].window.setContent(pointOfInterestInfoContent(point));
                }
            }
        }
    }

    handleEditGeoFence(geoFence: Geofence | null): void {
        if (geoFence) {
            this.clearAddOrEditGeoFenceState();
            this.editAndSelectGeoFence(geoFence);
            this.updateGeoFenceIDSGeoFence(geoFence);
        }
        this.setMapTye(google.maps.MapTypeId.ROADMAP);
    }

    handleRemovePolygons(): void {
        this.clearTmpPolygons();
        for (let i = 0; i < this.geoFenceIDS.length; i++) {
            const elements: google.maps.Polygon[] = this.geoFenceIDS[i].element as google.maps.Polygon[];
            for (let j = 0; j < elements.length; j++) {
                elements[j].setMap(null);
            }
        }
        this.geoFenceIDS = [];

        for (let i = 0; i < this.infoGeoFencesIDS.length; i++) {
            this.infoGeoFencesIDS[i].window.close();
        }
        this.infoGeoFencesIDS = [];
    }

    @Emit()
    changeVisibleMenu(visible: boolean) {}

    @Emit()
    changeVisibleGeoFenceMenu(visible: boolean) {}


    changeUserHasZoomed(value){
        this.userHasZoomed = value;
    }

    @Watch('$_getSelectedCompany')
    onCompanyChange(){
        this.changeUserHasZoomed(false);
        this.checkIfNeedToAdjustMarkersZoom();
    }

    @Watch('expandedPanel')
    onPanelExpanded(){
        this.changeUserHasZoomed(false);
        this.checkIfNeedToAdjustMarkersZoom();
    }

    @Watch('$_getOpenStatsPanel')
    onPanelVisibilityChange(value){
        this.changeUserHasZoomed(false);
        this.checkIfNeedToAdjustMarkersZoom();
    }

    @Watch('markers')
    onMarkersChange(){
        this.checkIfNeedToAdjustMarkersZoom();
    }

    checkIfNeedToAdjustMarkersZoom(){
        if(
            this.userHasZoomed
        ){
            // console.log("usuario hizo zoom, no deberia cambiarlo");
            return
        }

        if(this.markers.length == 0){
            // console.log("no hay marcadores para hacer zoom");
            return
        }

        // console.log("deberia ajustar el zoom a los markers");
        this.adjustZoom();
    }

    clickBtnCenter(){
         this.changeUserHasZoomed(false);
         this.adjustZoom();
    }



    adjustZoom(){
        // Initialize bounds
        const bounds = new google.maps.LatLngBounds();

        // Extend bounds for each marker
        this.markers.forEach(function(marker) {
            let googleMarker = getDefaultMarker(marker)
            if(marker.lat !== 0 && marker.lng !== 0){
                bounds.extend(googleMarker.position as google.maps.LatLng);
            }
        });

        let panelIsOpen = this.$_getOpenStatsPanel;
        let boundsPadding: google.maps.Padding = {
            top:0,
            left:100,
            right:100,
            bottom: 0
        }
        if (panelIsOpen) {
            let panelHeight = this.heightStatsPanel;
            let margin = 120;
            if(panelHeight > 700){
                margin = 0
            }

            boundsPadding.bottom = (panelHeight + margin);
        }

        this.googleMap.fitBounds(bounds, boundsPadding);
    }



    @Watch('visibleMenu')
    observerVisibleMenu(value: boolean): void {
        this.changeVisibleMenu(value);
    }

    @Watch('visibleGeoFenceMenu')
    observerVisibleGeoFenceMenu(value: boolean): void {
        this.changeVisibleMenu(value);
    }

    clearTmpAddPointMarker(): void {
        if (this.tmpAddPointMarker) {
            this.tmpAddPointMarker.map = null;
            this.tmpAddPointMarker = null;
        }
    }

    setDraggableCursor(): void {
        this.googleMap.setOptions({ draggableCursor: 'cell' });
    }

    listenAddPoint(): void {
        this.setDraggableCursor();
        if (!this.visibleMenu) {
            this.visibleMenu = true;
        }
        this.listenerAddPoint = google.maps.event.addListener(this.googleMap, mouseClickEvent, event => {
            this.$nextTick(() => {
                this.editPoint = false;
                this.addPointLat = event.latLng.lat();
                this.addPointLng = event.latLng.lng();
                this.clearTmpAddPointMarker();
                this.tmpAddPointMarker = this.createDefaultMarker({ lat: this.addPointLat, lng: this.addPointLng });
                this.tmpAddPointMarker.map = this.googleMap;
            });
        });
    }

    clearTmpPolygons(): void {
        for (let i = 0; i < this.tmpPolygons.length; i++) {
            this.tmpPolygons[i].setMap(null);
        }
        this.tmpPolygons = [];
    }

    listenAddGeoFence(): void {
        this.setMapTye(google.maps.MapTypeId.HYBRID);
        this.setDraggableCursor();
        this.clearTmpPolygons();
        if (!this.visibleGeoFenceMenu) {
            this.visibleGeoFenceMenu = true;
        }
        this.tmpPolygons.push(this.getNewPolygon());
        this.listenerAddGeoFence = google.maps.event.addListener(this.googleMap, mouseClickEvent, event => {
            this.editGeoFence = false;
            let currentPath: google.maps.MVCArray<google.maps.LatLng> = this.getLastPolygon().getPath();
            currentPath.push(event.latLng);
        });
    }

    getNewPolygon(): google.maps.Polygon {
        return this.createDefaultPolygon(undefined, true, true);
    }

    getLastPolygon(): google.maps.Polygon {
        return this.tmpPolygons[this.tmpPolygons.length - 1];
    }

    handleGeofenceSelected(value){
        this.selectedGeofence = value;
    }

    handleFinalizePolygon(): void {
        let lastPolygon = this.getLastPolygon();
        let position = this.tmpPolygons.length - 1;
        google.maps.event.addListener(lastPolygon, 'rightclick', event => {
            this.clickedElementIsTmpPolygon = true;
            this.clickedTmpPolygon = position;
            this.openMenu(event);
        });
        this.tmpPolygons.push(this.getNewPolygon());
    }

    listenEditPoint(point: PointsOfInterest): void {
        this.addPointLat = point.point.lat;
        this.addPointLng = point.point.lng;

        this.setDraggableCursor();
        this.editPoint = true;
        this.pointToEdit = point;
        this.editPointDescription = point.description;
        this.pointId = point.point_of_interest_id;
        if (!this.visibleMenu) {
            this.visibleMenu = true;
        }
        this.listenerEditPoint = google.maps.event.addListener(this.googleMap, mouseClickEvent, event => {
            this.$nextTick(() => {
                this.addPointLat = event.latLng.lat();
                this.addPointLng = event.latLng.lng();
                this.setPositionToPointsOfInterest(point.point_of_interest_id, event.latLng);
            });
        });
    }

    setStateToGeoFence(id: string, draggable: boolean, editable: boolean): void {
        for (let i = 0; i < this.geoFenceIDS.length; i++) {
            if (this.geoFenceIDS[i].id === id) {
                let polygons: google.maps.Polygon[] = this.geoFenceIDS[i].element as google.maps.Polygon[];
                for (let j = 0; j < polygons.length; j++) {
                    //here
                    polygons[j].setOptions({
                        zIndex: 99,
                        clickable: false
                    });
                    polygons[j].setDraggable(draggable);
                    polygons[j].setEditable(editable);
                }
            }
        }
    }

    get getCustomClassMapLoader(){
        if(this.$_getFilterDate === TypeFilterDate.TR){
            return 'map-filter-now map-travel'
        }else{
            return 'map-travel'
        }
    }

    updateGeoFenceIDSGeoFence(geoFence: Geofence): void {
        const clean: (number | string)[] = this.cleanElements<Geofence>(
            [geoFence],
            this.geoFenceIDS,
            this.infoGeoFencesIDS,
            GEO_FENCE_KEY
        );
        this.geoFenceIDS = this.geoFenceIDS.filter(
            geo => !clean.find(cleanId => cleanId.toString() === geo.id.toString())
        );
        this.infoGeoFencesIDS = this.infoGeoFencesIDS.filter(
            geo => !clean.find(cleanId => cleanId.toString() === geo.id.toString())
        );

        this.addGeoFence([geoFence]);
    }

    listenEditGeoFence(geoFence: Geofence): void {
        this.setDraggableCursor();
        this.clearTmpPolygons();
        this.setMapTye(google.maps.MapTypeId.HYBRID);
        this.setStateToGeoFence(geoFence.geofence_id, true, true);
        this.editGeoFence = true;
        // geoFence['reports'] = 2;
        this.geoFenceToEdit = geoFence;
        this.geoFenceId = geoFence.geofence_id;
        if (!this.visibleGeoFenceMenu) {
            this.visibleGeoFenceMenu = true;
        }
        this.editGeofenceChoice = geoFence.geofence_type;
        this.editGeoFenceDescription = geoFence.description;
        this.listenerEditGeoFence = google.maps.event.addListener(this.googleMap, mouseClickEvent, event => {
            if (!hasElements(this.tmpPolygons)) {
                this.tmpPolygons.push(this.getNewPolygon());
            }
            let currentPath: google.maps.MVCArray<google.maps.LatLng> = this.getLastPolygon().getPath();
            currentPath.push(event.latLng);
        });
    }

    listenAddOrEditElementOff(): void {
        if (this.listenerAddPoint) {
            google.maps.event.removeListener(this.listenerAddPoint);
            this.listenerAddPoint = null;
        }
        if (this.listenerEditPoint) {
            google.maps.event.removeListener(this.listenerEditPoint);
            this.listenerEditPoint = null;
        }
        if (this.listenerAddGeoFence) {
            google.maps.event.removeListener(this.listenerAddGeoFence);
            this.listenerAddGeoFence = null;
        }
        if (this.listenerEditGeoFence) {
            google.maps.event.removeListener(this.listenerEditGeoFence);
            this.listenerEditGeoFence = null;
        }
    }

    searchMissingAndAddedGeoFences(oldValue: Geofence[], newValue: Geofence[]): SearchOfGeoFence {
        const missingGeoFences = this.searchMissing<Geofence>(oldValue, newValue, GEO_FENCE_KEY);
        const addedGeoFences = this.searchAddedElement<Geofence>(newValue, this.geoFenceIDS, GEO_FENCE_KEY);
        return {
            added: addedGeoFences,
            missing: missingGeoFences
        };
    }

    cleanElements<T>(
        missing: T[],
        elementsId: ElementId[],
        infosId: InfoWindowID[],
        idKey: string
    ): (number | string)[] {
        const clean: (number | string)[] = [];
        for (let i = 0; i < elementsId.length; i++) {
            for (let j = 0; j < missing.length; j++) {
                if (elementsId[i].id.toString() === missing[j][idKey].toString()) {
                    if (Array.isArray(elementsId[i].element)) {
                        for (let k = 0; k < (<google.maps.Polygon[]>elementsId[i].element).length; k++) {
                            (<google.maps.Polygon[]>elementsId[i].element)[k].setMap(null);
                        }
                    } else {
                        (<google.maps.marker.AdvancedMarkerElement>elementsId[i].element).map = null
                    }

                    google.maps.event.clearInstanceListeners(elementsId[i].element);
                    clean.push(elementsId[i].id);
                }
            }
        }

        for (let i = 0; i < infosId.length; i++) {
            for (let j = 0; j < missing.length; j++) {
                if (infosId[i].id.toString() === missing[j][idKey].toString()) {
                    infosId[i].window.close();
                }
            }
        }
        return clean;
    }

    get noExistVisualizationApply(): boolean {
        return !hasElements(this.visualizationApply.markers);
    }

    get existVisualizationApply(): boolean {
        return hasElements(this.visualizationApply.markers);
    }

    @Emit()
    addAndSelectPointOfInterest(point: PointsOfInterest | null): void {}

    @Emit()
    editAndSelectPointOfInterest(point: PointsOfInterest | null): void {}

    @Emit()
    addAndSelectGeoFence(geoFence: Geofence | null): void {}

    @Emit()
    editAndSelectGeoFence(geoFence: Geofence | null): void {}

    @Emit()
    waitForEditGeoFence(geoFence: Geofence): void {}

    @Emit()
    waitForEditPoint(point: PointsOfInterest): void {}
}
